import { BFF_PROXY_API } from 'constants/apiRoutes';

import { axiosWithoutRetries } from 'shared/api/requestInstance';
import type { TDadataFullAddressSelectOption } from 'shared/types';

export const getFullAddressesAutocomplete = async (
  query: string,
): Promise<TDadataFullAddressSelectOption | null | undefined> => {
  try {
    const { data } = await axiosWithoutRetries.post<TDadataFullAddressSelectOption[]>(
      BFF_PROXY_API.getFullAddressesAutocomplete,
      {
        search: query,
        bound: 'house',
      },
    );

    return Array.isArray(data) ? (data[0] ?? null) : null;
  } catch {
    return undefined;
  }
};
